import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useImperativeHandle } from "react"
import { Table, message } from "antd"
import YhIcon from "@/components/pubIcon"
import ItemDrawer from "@/components/pubPartDrawer/itemDrawer" //项目弹框
import { EditableRow, EditableCell } from "./editble"

//其他项目
export default ({ maintenanceRef, list }) => {
    const {t} = useTranslation()
    const [data, setData] = useState([]) //表格数据
    const [visible, setVisible] = useState(false) //弹框
    useEffect(() => {
        console.log(111)
        console.log(list)
        setData(list)
    }, [list])

    //暴露给父组件的方法
    useImperativeHandle(maintenanceRef, () => ({
        //父组件保存的时候 获取所有编辑完后的数据
        upData: () => {
            console.log(data)
            return data
        },
    }))

    
    const [MaterialKeys, setMaterialKeys] = useState([]) // 批量删除的key
    const [deleteAll, setDeleteAll] = useState(false) //删除多选的控制按钮
    //批量删除多选的成员id
    const MaterialSelection = {
        columnWidth: "30px",
        onChange: (selectedRowKeys, selectedRows) => {
            setMaterialKeys(selectedRowKeys)
        },
    }
    //批量删除
    const deleteTemaAll = () => {
        if (MaterialKeys.length === 0) {
            message.warning(t(`dataManage.combination.maintenance.请选择你要删除的项目`))
            return
        }
        let arr = data.filter((item) => MaterialKeys.indexOf(item.id) < 0 && MaterialKeys.indexOf(item.temporaryId))
        setDeleteAll(false)
        setData(arr)
        setMaterialKeys([])
        message.success(t(`dataManage.combination.maintenance.批量删除成功`))
    }
    //维修物料删除一条数据
    const deleteMaterialOne = (row) => {
        //删除已选的
        let newData = [...data]
        let delIndex
        if (row.id) {
            delIndex = newData.findIndex((item) => item.id === row.id)
        } else {
            delIndex = newData.findIndex((item) => item.temporaryId === row.temporaryId)
        }
        newData.splice(delIndex, 1)
        setData(newData)
        message.success(t(`dataManage.combination.maintenance.删除成功`))
    }

    //新增确定。 有选中的，过滤掉列表里面有的，在合并到一起。
    const setItemList = (setItemList) => {
        if (setItemList.length) {
            let newArr = []
            setItemList.forEach((item) => {
                if (data.findIndex((i) => i.itemId === item.id) === -1) {
                    let itemData = {
                        ...item,
                        temporaryId: new Date().getTime() + parseInt(Math.random() * 100000),
                        itemId: item.id,
                        id: null
                    }
                    newArr.push(itemData)
                }
            })
            setData([...data, ...newArr])
        }
        setVisible(false)
    }

    //选中展示table配置
    const columns = [
        {
            title: t(`dataManage.combination.maintenance.序号`),
            width: 40,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1,
        },
        {
            title: t(`dataManage.combination.maintenance.项目编码`),
            align: "center",
            width: 120,
            dataIndex: "itemCode",
            sorter: (a, b) => a.itemCode.localeCompare(b.itemCode),
        },
        {
            title: t(`dataManage.combination.maintenance.项目名称`),
            align: "center",
            width: 120,
            dataIndex: "itemName",
            sorter: (a, b) => a.itemName.localeCompare(b.itemName),
        },
        {
            title: t(`dataManage.combination.maintenance.系统分类`),
            align: "center",
            width: 120,
            dataIndex: "itemClassificationName",
        },
        {
            title: t(`dataManage.combination.maintenance.备注`),
            align: "center",
            width: 120,
            dataIndex: "remark",
            editable: true,
        },
        {
            title: t(`dataManage.combination.maintenance.操作`),
            align: "center",
            width: "80px",
            dataIndex: "operation",
            render: (_, record) => {
                return <YhIcon type="icon-guanbi" style={{ color: "#D81E06", cursor: "pointer" }} onClick={() => deleteMaterialOne(record)} />
            },
        },
    ]
     //单元格编辑保存
     const materialHandleSave = (row, status) => {
        const newData = [...data]
        const index = newData.findIndex((item) => row.id === item.id && item.temporaryId === row.temporaryId)
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        setData(newData)
    }

    const MaterialColumns = columns.map((col) => {
        if (!col.editable) {
            return col
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: materialHandleSave,
            }),
        }
    })
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    }

    return (
        <div className="list-container" style={{ marginBottom: "100px" }}>
            <div className="list-header">
                <div className="list-name">
                    <span> {t(`dataManage.combination.maintenance.维修项目`)}</span>
                    <div className="list-name-but">
                        <YhIcon type="icon-zengjia" style={{ color: "#37B36F", fontSize: "26px" }} onClick={() => setVisible(true)} />
                        {!deleteAll ? (
                            <span className="list-delete" onClick={() => setDeleteAll(true)}>
                                 {t(`dataManage.combination.maintenance.批量删除`)}
                            </span>
                        ) : (
                            <>
                                <span className="list-delete" onClick={deleteTemaAll}>
                                     {t(`dataManage.combination.maintenance.确认删除`)}
                                </span>
                                <span className="list-delete" onClick={() => setDeleteAll(false)}>
                                     {t(`dataManage.combination.maintenance.取消`)}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Table
                size="small"
                rowKey={(record) => record.id || record.temporaryId}
                columns={MaterialColumns}
                dataSource={data}
                pagination={false}
                scroll={{ y: 260 }}
                rowSelection={deleteAll ? MaterialSelection : false}
                components={components}
            />
            <ItemDrawer visible={visible} onClose={(bool) => setVisible(bool)} onItemOk={setItemList} drawerMode="item" />
        </div>
    )
}
